const LOGIN_PATH = '/login';

const DESKTOP_PATH = '/';
const DESKTOP_ARCHIVE_COMPLAINT_CASE_PATH = '/area-de-trabalho/arquivar-caso/'; // Simplified for frontend

const DEFAULT_DELETE_PATH = '/deletar/'; 

const STAFF_LIST_PATH = '/lista-de-colabordores';
const STAFF_ADD_PATH = '/adicionar-colaborador';
const STAFF_EDIT_PATH = '/editar-colaborador/';

const USER_PASSWORD_RECOVERY_PAGE = '/recuperacao-de-senha/';

const DOCUMENT_LIST_PATH = '/lista-de-documentos';
const DOCUMENT_ADD_PATH = '/adicionar-documento';
const DOCUMENT_EDIT_PATH = '/editar-documento/';

const COMPLAINT_TYPE_LIST_PATH = '/lista-de-queixas';
const COMPLAINT_TYPE_ADD_PATH = '/adicionar-queixa';
const COMPLAINT_TYPE_EDIT_PATH = '/editar-queixa/';

const CLINIC_LIST_PATH = '/lista-de-clientes';
const CLINIC_ADD_PATH = '/adicionar-cliente';
const CLINIC_EDIT_PATH = '/editar-cliente/';

const PATIENT_LIST_PATH = '/lista-de-pacientes';
const PATIENT_ADD_PATH = '/adicionar-paciente';
const PATIENT_EDIT_PATH = '/editar-paciente/';

const COMPLAINT_CASE_LIST_PATH = '/lista-de-casos';
const COMPLAINT_CASE_ADD_PATH = '/adicionar-caso';
const COMPLAINT_CASE_EDIT_PATH = '/editar-caso/';

const COMPLAINT_CASE_FORM_PATH = '/caso/{id}/formulario';
const COMPLAINT_CASE_FORM_BY_HASH_PATH = '/caso/formulario/';

export {
    LOGIN_PATH,
    DESKTOP_PATH,
    DESKTOP_ARCHIVE_COMPLAINT_CASE_PATH,
    DEFAULT_DELETE_PATH,
    STAFF_LIST_PATH,
    STAFF_ADD_PATH,
    STAFF_EDIT_PATH,
    USER_PASSWORD_RECOVERY_PAGE,
    DOCUMENT_LIST_PATH,
    DOCUMENT_ADD_PATH,
    DOCUMENT_EDIT_PATH,
    COMPLAINT_TYPE_LIST_PATH,
    COMPLAINT_TYPE_ADD_PATH,
    COMPLAINT_TYPE_EDIT_PATH,
    CLINIC_LIST_PATH,
    CLINIC_ADD_PATH,
    CLINIC_EDIT_PATH,
    PATIENT_LIST_PATH,
    PATIENT_ADD_PATH,
    PATIENT_EDIT_PATH,
    COMPLAINT_CASE_LIST_PATH,
    COMPLAINT_CASE_ADD_PATH,
    COMPLAINT_CASE_EDIT_PATH,
    COMPLAINT_CASE_FORM_PATH,
    COMPLAINT_CASE_FORM_BY_HASH_PATH
};